import React from "react";
import { ProfileContactInfoComponent } from "../../../services/types/ComponentTypes";
import { useDarkMode } from "../../../contexts/DarkModeContext";

interface ProfileContactInfoProps {
    component: ProfileContactInfoComponent;
    formData: any;
}

const ProfileContactInfo: React.FC<ProfileContactInfoProps> = ({
    component,
    formData,
}) => {
    const { isDarkMode } = useDarkMode();
    const getIcon = (name: string) => {
        switch (name) {
            case "contact_email":
                return (
                    <svg width="16" height="16" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                        <path d="M3.75 6.25V13.75C3.75 14.4404 4.30964 15 5 15H15C15.6904 15 16.25 14.4404 16.25 13.75V6.25" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                        <path d="M4.5 6.75L9.24 10.31C9.686 10.6445 10.314 10.6445 10.76 10.31L15.5 6.75" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                );
            case "contact_phone":
                return (
                    <svg width="16" height="16" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                        <path d="M7.25 3.75L8.6 6.8C8.76 7.17 8.67 7.6 8.37 7.88L7.1 9.15C8.07 10.88 9.12 11.93 10.85 12.9L12.12 11.63C12.4 11.33 12.83 11.24 13.2 11.4L16.25 12.75V15C16.25 15.69 15.69 16.25 15 16.25C8.23 16.25 3.75 11.77 3.75 5C3.75 4.31 4.31 3.75 5 3.75H7.25Z" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                );
            case "contact_location":
                return (
                    <svg width="16" height="16" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                        <path d="M10 16.25S5.625 12.87 5.625 8.75C5.625 6.333 7.583 4.375 10 4.375C12.417 4.375 14.375 6.333 14.375 8.75C14.375 12.87 10 16.25 10 16.25Z" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M10 9.75C10.5523 9.75 11 9.30228 11 8.75C11 8.19772 10.5523 7.75 10 7.75C9.44772 7.75 9 8.19772 9 8.75C9 9.30228 9.44772 9.75 10 9.75Z" fill="currentColor" />
                    </svg>
                );
            case "contact_emp_code":
                return (
                    <svg width="16" height="16" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                        <path d="M7 5.5L6 14.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                        <path d="M14 5.5L13 14.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                        <path d="M5.5 8H14.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                        <path d="M5 12H14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                    </svg>
                );
            default:
                return null;
        }
    };

    // Cast style to any to bypass type mismatch
    const containerStyle = { ...component.style, display: "flex", gap: 14, flexWrap: "wrap" } as any;
    const itemColor = isDarkMode ? "#e2e8f0" : "#334155";
    const muted = isDarkMode ? "#94a3b8" : "#64748b";

    return (
        <div style={containerStyle}>
            {component.fields?.map((field: any, index: number) => {
                const value = formData[field.BindValue];
                return (
                    <div
                        key={index}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            color: itemColor,
                            padding: "6px 10px",
                            borderRadius: 999,
                            border: `1px solid ${isDarkMode ? "rgba(51,65,85,0.9)" : "rgba(148,163,184,0.35)"}`,
                            background: isDarkMode ? "rgba(15,23,42,0.25)" : "rgba(248,250,252,0.85)",
                        }}
                    >
                        <span style={{ color: muted, display: "inline-flex", alignItems: "center" }}>{getIcon(field.name)}</span>
                        <span style={{ fontSize: 13, fontWeight: 600 }}>{value || "—"}</span>
                    </div>
                );
            })}
        </div>
    );
};

export default ProfileContactInfo;
